export const tableItems = [
    {
        label: 'Anfrage akzeptieren',
        credits: 30,
        description: 'Sobald Du die Anfrage eines Mitglieds annimmst.',
        link: 'https://support.horsedeal.com/hc/de/articles/27386985127314',
    },

    {
        label: 'Match schenken',
        credits: 30,
        description:
            'Wenn Du die Option „Match schenken“ aktivierst und deine Anfrage akzeptiert wird.',
        link: 'https://support.horsedeal.com/hc/de/articles/27387157273618',
    },
    {
        label: 'Ansichten aufdecken',
        credits: 10,
        description: 'Sobald Du die Ansicht eines Mitglieds freischaltest.',
        link: 'https://support.horsedeal.com/hc/de/articles/27387087763090',
    },
    {
        label: 'Privates Profil',
        credits: 10,
        description:
            'Wenn das Paket „Privates Profil“ aktiv ist und Du eine Anfrage sendest oder erhältst.',
        link: 'https://support.horsedeal.com/hc/de/articles/27387051412114',
    },
    {
        label: 'Anonymes Profil',
        credits: 10,
        description:
            'Wenn das Paket „Anonymes Profil“ aktiv ist und Du eine Anfrage sendest oder erhältst.',
        link: 'https://support.horsedeal.com/hc/de/articles/27387130476050',
    },
    {
        label: 'Social Boost',
        credits: 20,
        description:
            'Wenn das Paket „Social Boost“ aktiv ist und Du eine Anfrage sendest oder erhältst.',
        link: 'https://support.horsedeal.com/hc/de/articles/27387157273618',
    },
];
